import { CardMediaProps as MuiCardMediaProps } from '@mui/material/CardMedia'

export interface CardMediaProps extends MuiCardMediaProps<'img'> {
  component?: React.ElementType
}
